module.exports = __webpack_public_path__ + "img/ontag-logo.6072ba56.png";